import { Location } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { asapScheduler, scheduled, Subscription } from 'rxjs';
import { filter, switchMap, withLatestFrom } from 'rxjs/operators';
import { createTag, createTagsSuccess, deleteTag, updateTag, updateTagSuccess } from '../../app.actions';
import { Tag } from '../../app.models';
import { selectApiEndpoint, selectRouteParams, selectUrl } from '../../app.selector';
import { TestPushComponent } from '../test-push/test-push.component';

@Component({
  selector: 'app-tag-detail',
  templateUrl: './tag-detail.component.html',
})
export class TagDetailComponent implements OnInit, OnDestroy {

  @ViewChild('deleteDialog') deleteDialog: TemplateRef<any>;
  tag = {} as Tag;
  isNew: boolean;
  tag$: Subscription;
  updates$: Subscription;
  expiration: Date;
  type: string;
  constructor(
    private store: Store,
    private http: HttpClient,
    private title: Title,
    private router: Router,
    private route: ActivatedRoute,
    private updates: Actions,
    private dialogService: NbDialogService,
    private cd: ChangeDetectorRef,
    public location: Location
  ) { }

  ngOnInit() {

    // reload after update
    this.updates$ = this.updates.pipe(
      ofType(updateTagSuccess, createTagsSuccess),
      withLatestFrom(
        this.store.select(selectRouteParams),
      ),
    ).subscribe(([action, params]) => {
      this.title.setTitle(action.payload.name);
      this.tag = { ...action.payload };
      this.expiration = action.payload.expiration ? (new Date(action.payload.expiration)) : null;
      if (params.id === 'new') {
        this.isNew = false;
        this.router.navigate([`/${params.clientId}/tags/${action.payload.id}`]);
      }
    });

    // fetch fresh
    this.tag$ = this.store.select(selectApiEndpoint).pipe(
      filter((c) => !!c),
      withLatestFrom(
        this.store.select(selectUrl),
        this.store.select(selectRouteParams),
      ),
      switchMap(([endpoint, url, params]) => {
        if (params.id === 'new') {
          const tag = {
            group: params.type === 'group',
            parentId: 0
          } as Tag;
          return scheduled([tag], asapScheduler);
        }
        return this.http.get(`${endpoint}${url}`)
      })
    ).subscribe(
      (tag: Tag) => {
        this.isNew = tag.id ? false : true;
        this.type = tag.group ? 'Tag Group' : 'Tag';
        this.title.setTitle(`${this.isNew ? 'new ' : ''}${tag.name || this.type}`);
        this.tag = { ...tag };
        this.expiration = tag.expiration ? (new Date(tag.expiration)) : null;
      },
      (e: HttpErrorResponse) => this.router.navigate(['/404'], { state: { msg: 'The tag doesn\'t exist.' } })
    )
  }


  save() {
    this.tag.expiration = this.expiration ? this.expiration.getTime() : 0;
    if (this.isNew) {
      this.store.dispatch(createTag({ payload: this.tag }));
    } else {
      this.store.dispatch(updateTag({ payload: this.tag }));
    }
  }

  handleClickDelete() {
    this.cd.detectChanges();
    const context = {
      tag: this.tag,
      delete: () => {
        this.router.navigate(['..'], { relativeTo: this.route });
        this.store.dispatch(deleteTag({ payload: this.tag }));
      }
    }
    // https://github.com/swimlane/ngx-datatable/issues/721#issuecomment-325550591
    setTimeout(() => {
      this.dialogService.open(this.deleteDialog, { context });
    })
  }

  testpush() {
    this.dialogService.open(TestPushComponent, {
      context: {
        contextTag: this.tag,
      },
    });
  }

  ngOnDestroy() {
    this.tag$.unsubscribe();
    this.updates$.unsubscribe();
  }
}
